import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ProductInfo } from "abweb/dto/product/ProductInfo";
import { MethodType } from "abweb/service/rpc/MethodType";
import { FetchUtils } from "abweb/service/utils/rpc/FetchUtils";
import { URLUtils } from "abweb/utils/URLUtils";
export class ProductService {
  constructor(rpcService) {
    this.rpcService = rpcService;
  }
  getProductInfo() {
    return this.rpcService.invokeRetObj(ProductService.PRODUCT_INFO_RPC_URL, null, ProductInfo, MethodType.GET);
  }

  /**
   * Supports determining if external products are alive.  It will either return (signifying that it was able to
   * reach the external product), or it will throw if unable to reach it.
   * @param relativeRootUrl
   */
  async getProductInfoProbe(relativeRootUrl = "") {
    // Do NOT use rpcService as the exception handling code might trigger the 'lost session' workflows which are
    // not applicable to probes (esp. before user authentication)
    const absUrl = URLUtils.getAbsoluteUrl(relativeRootUrl + ProductService.PRODUCT_INFO_RPC_URL);
    console.log("probe:", absUrl);
    const productInfoJson = await FetchUtils.fetchAndParseJsonFile(absUrl);
  }
}
_defineProperty(ProductService, "PRODUCT_INFO_RPC_URL", "/api/abweb/product/productInfo");
//# sourceMappingURL=ProductService.js.map
